import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/companies_/$companyId/users_/$userId/subscriptions')({
  beforeLoad: ({ params }): never => {
    throw redirect({
      to: '/companies/$companyId/users/$userId/subscription',
      params,
    })
  },
})
